// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__UIb1y","inner":"Footer_inner__2_ar3"};